import {FETCH_INTERVENTIONS} from "../constants/ActionTypes";
import {INIT_INTERVENTION_FILTERS, INIT_INTERVENTION_PAGINATION} from "../constants/filters";

const initialState = {
  counters: {
    interventionStatus: {},
    type: {}
  },
  filters: INIT_INTERVENTION_FILTERS,
  interventions: [],
  pagination: INIT_INTERVENTION_PAGINATION,
};

export function interventionsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_INTERVENTIONS:
      return {
        ...state,
        filters: action.filters,
        pagination: {
          currentPage: action.parameters.page,
          currentPageSize: action.parameters.size,
        },
      }
    case 'FETCH_INTERVENTIONS.SUCCESS':
    case 'FETCH_INTERVENTIONS_OVERVIEW.SUCCESS':
      return {
        ...state,
        counters: {
          interventionStatus: action.statusCounters,
          type: action.typeCounters,
        },
        interventions: action.interventions.body,
        pagination: {
          currentPage: action.interventions.body.number + 1,
          currentPageSize: action.interventions.body.size,
          totalElements: action.interventions.body.totalElements
        },
      }
    default:
      return {...state}
  }
}
